import React from 'react';


export default function CustomLabel(props) {
    return(
        <div>
            <span style={{color:'#80949D'}}>{props?.label}{' '}</span>
            {props.isLineChange && <br/>}
            <span style={{color:'#00293B'}}>{props?.labelValue}</span>
        </div>
    )
}

// How to use

{/* <CustomLabel
    label={'Curriculum Name:'}
    labelValue={'B. Tech in CSE xyz - pqr'}
    isLineChange
/> */}